export const appName = 'taxi-web'

export const DEFAULT_CONFIG_NAME = '0'

export const WHATSAPP_BOT_URL = 'http://localhost:7000'
export const WHATSAPP_BOT_KEY = '1472'